var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.8,
    height: 22.7,
    viewBox: "0 0 23.8 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,1.5C21.5,0.7,20.8,0,20,0h-3c-0.8,0-1.5,0.7-1.5,1.5V3h6V1.5z M22.3,4.5h-7.6c-0.8,0-1.5,0.7-1.5,1.5 v15.1c0,0.8,0.7,1.5,1.5,1.5h7.6c0.8,0,1.5-0.7,1.5-1.5V6C23.8,5.2,23.1,4.5,22.3,4.5z M20,19.6h-3c-0.4,0-0.8-0.3-0.8-0.8 c0-0.4,0.3-0.8,0.8-0.8h3c0.4,0,0.8,0.3,0.8,0.8C20.8,19.3,20.4,19.6,20,19.6z M20,9.1h-0.8v0.8c0,0.4-0.3,0.8-0.8,0.8 c-0.4,0-0.8-0.3-0.8-0.8V9.1H17c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h0.8V6.8c0-0.4,0.3-0.8,0.8-0.8 c0.4,0,0.8,0.3,0.8,0.8v0.8H20c0.4,0,0.8,0.3,0.8,0.8C20.8,8.7,20.4,9.1,20,9.1z M8.3,1.5C8.3,0.7,7.6,0,6.8,0h-3 C2.9,0,2.3,0.7,2.3,1.5V3h6V1.5z M9.1,4.5H1.5C0.7,4.5,0,5.2,0,6v15.1c0,0.8,0.7,1.5,1.5,1.5h7.6c0.8,0,1.5-0.7,1.5-1.5V6 C10.6,5.2,9.9,4.5,9.1,4.5z M6.8,19.6h-3c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h3c0.4,0,0.8,0.3,0.8,0.8 C7.6,19.3,7.2,19.6,6.8,19.6z M6.8,9.1H6v0.8c0,0.4-0.3,0.8-0.8,0.8c-0.4,0-0.8-0.3-0.8-0.8V9.1H3.8C3.4,9.1,3,8.7,3,8.3 c0-0.4,0.3-0.8,0.8-0.8h0.8V6.8C4.5,6.4,4.9,6,5.3,6C5.7,6,6,6.4,6,6.8v0.8h0.8c0.4,0,0.8,0.3,0.8,0.8C7.6,8.7,7.2,9.1,6.8,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrayIcon);
export default __webpack_public_path__ + "static/media/array-icon.d070bfc12078a05360de816aa58d33c7.svg";
export { ForwardRef as ReactComponent };